const Product = ({
    // deprecate
    isEligibleForLeadGuarantee = false,
    paymentValidDuration = '',
    // deprecate
    price = '',
    type = -1,
} = {}) => ({
    isEligibleForLeadGuarantee: Boolean(isEligibleForLeadGuarantee),
    paymentValidDuration: String(paymentValidDuration),
    price: String(price),
    type: Number(type),
});

const PaidInclusionDetails = ({
    isEligibleForLeadGuarantee = false,
    isFlatFeeEnabled = false,
    price = '',
    products = [],
} = {}) => ({
    isEligibleForLeadGuarantee: Boolean(isEligibleForLeadGuarantee),
    isFlatFeeEnabled: Boolean(isFlatFeeEnabled),
    price: String(price),
    products: products.map(product => Product(product)),
});

export default PaidInclusionDetails;
